const TONES = {
  default: "bg-white border-slate-200",
  green: "bg-emerald-50 border-emerald-200",
  red: "bg-rose-50 border-rose-200",
  blue: "bg-sky-50 border-sky-200",
  navy: "bg-gradient-to-br from-cyan-600 to-blue-900 border-transparent text-white",
};
const VALUE = { default: "text-slate-900", green: "text-emerald-700", red: "text-rose-700", blue: "text-sky-700", navy: "text-white" };

export function StatCard({ label, value, icon: Icon, tone = "default", hint, testId }) {
  return (
    <div
      data-testid={testId}
      className={`rounded-2xl border p-5 shadow-sm transition-transform duration-200 hover:-translate-y-0.5 ${TONES[tone]}`}
    >
      <div className="flex items-center justify-between">
        <span className={`text-xs font-semibold uppercase tracking-wider ${tone === "navy" ? "text-cyan-100" : "text-slate-500"}`}>
          {label}
        </span>
        {Icon && <Icon className={`h-4 w-4 ${tone === "navy" ? "text-cyan-200" : "text-slate-400"}`} />}
      </div>
      <div className={`mt-3 font-mono text-2xl font-bold tracking-tight sm:text-[1.7rem] ${VALUE[tone]}`}>{value}</div>
      {hint && <div className={`mt-1 text-xs ${tone === "navy" ? "text-cyan-100" : "text-slate-500"}`}>{hint}</div>}
    </div>
  );
}
